import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesSupportTickets } from "../../constants/enums";
import { CreateReturnFromTicketBody } from "./createReturnFromTicket.types";

export const requestCreateReturnFromTicket = async ({
  ticketId,
  ...body
}: CreateReturnFromTicketBody): Promise<void> => {
  return await instance.post(
    buildUrl(ApiRoutesSupportTickets.Tickets, ticketId, "return"),
    body,
  );
};
